import { Form } from "antd";
import { useEffect } from "react";
import { FormModal } from "@/shared/components/FormModal";
import { useCreateUser, useUpdateUser } from "../hooks/useUsers";
import { useUsersStore } from "../store/users.store";
import type { CreateUserRequest } from "../types";
import { UserForm } from "./UserForm";

export function UserFormModal() {
	const [form] = Form.useForm<CreateUserRequest>();
	const { modalOpen, editingUser, closeModal } = useUsersStore();

	const { mutate: create, isPending: isCreating } = useCreateUser();
	const { mutate: update, isPending: isUpdating } = useUpdateUser();

	const close = () => {
		form.resetFields();
		closeModal();
	};

	useEffect(() => {
		if (modalOpen) {
			if (editingUser) {
				form.setFieldsValue({
					fullname: editingUser.fullname,
					phone: editingUser.phone,
				});
			} else {
				form.resetFields();
			}
		}
	}, [modalOpen, editingUser, form]);

	const onFinish = (values: CreateUserRequest) => {
		if (editingUser) {
			const updateData: Partial<CreateUserRequest> = {};
			if (values.fullname !== editingUser.fullname) {
				updateData.fullname = values.fullname;
			}
			if (values.phone !== editingUser.phone) {
				updateData.phone = values.phone;
			}
			if (values.password) {
				updateData.password = values.password;
			}
			update({ id: editingUser.id, data: updateData }, { onSuccess: close });
		} else {
			create(values, { onSuccess: close });
		}
	};

	return (
		<FormModal
			title="Yangi foydalanuvchi"
			editTitle="Foydalanuvchini tahrirlash"
			editing={!!editingUser}
			open={modalOpen}
			onCancel={close}
			onOk={form.submit}
			confirmLoading={isCreating || isUpdating}
		>
			<Form form={form} layout="vertical" requiredMark={false} onFinish={onFinish}>
				<UserForm />
			</Form>
		</FormModal>
	);
}
